import styled from 'styled-components';
import { Select } from 'antd';

export const StyledSideMenuSelect = styled(Select)`
  .ant-select-selector {
    background: #121212 !important; // Фоновый цвет селектора
    color: #fff !important; // Цвет текста селектора
    border: none !important; // Убрать бордер, если нужно
    border-radius: 4px !important; // Радиус скругления
    height: 32px !important; // Высота селектора
  }

  .ant-select-item {
    color: #fff !important; // Цвет текста элементов в выпадающем списке
    background: #121212 !important; // Фоновый цвет элементов в выпадающем списке
  }

  .ant-select-item-option-selected {
    background: #ff7300 !important; // Фоновый цвет выбранного элемента
    color: #fff !important; // Цвет текста выбранного элемента
  }

  .ant-select-item-option-active {
    background: #ff7300 !important; // Фоновый цвет элемента при наведении
    color: #fff !important; // Цвет текста элемента при наведении
  }

  .ant-select-arrow {
    color: #fff !important; // Цвет стрелки раскрытия
  }

  .ant-select-disabled .ant-select-selector {
    background: #121212 !important; // Фоновый цвет для отключенного селектора
    color: rgba(255, 255, 255, 0.5) !important; // Цвет текста для отключенного селектора
  }
`;
